import { useState } from 'react';
import { HeroSection } from './components/HeroSection';

import { ProductSection } from './components/ProductSection';
import { AboutSection } from './components/AboutSection';
import { ProjectsSection } from './components/ProjectsSection';
import { ContactSection } from './components/ContactSection';
import { FooterSection } from './components/FooterSection';
import { CursorGlow } from './components/CursorGlow';
import Aurora from './components/Aurora';
import Header from '@/components/feature/Header';
import { SEOSchema } from '@/components/feature/SEOSchema';

export default function HomePage() {
  const [lang, setLang] = useState<'pt' | 'en'>('pt');

  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEOSchema lang={lang} />

      {/* Global Aurora Background */}
      <div className="fixed inset-0 z-0">
        <Aurora
          colorStops={['#ed66ff', '#b19eef', '#5227ff']}
          amplitude={1.2}
          blend={0.6}
          speed={0.8}
        />
      </div>

      {/* Global Effects */}
      <CursorGlow />

      {/* Header with lang toggle */}
      <Header lang={lang} setLang={setLang} />

      {/* Content with relative positioning */}
      <div className="relative z-10">
        <HeroSection lang={lang} />

        {/* Black overlay for sections below hero */}
        <div className="relative">
          <div className="absolute inset-0 bg-black/30 z-0"></div>
          <div className="relative z-10">
            <ProductSection lang={lang} />
            <AboutSection lang={lang} />
            <ProjectsSection lang={lang} />
            <ContactSection lang={lang} />
            <FooterSection lang={lang} />
          </div>
        </div>
      </div>
    </div>
  );
}
